import { render } from "./Details.vue?vue&type=template&id=475eb5bf&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=475eb5bf&scoped=true&lang=css"
import "./Details.vue?vue&type=style&index=1&id=475eb5bf&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475eb5bf"]])

export default __exports__